import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES, CONTACT } from "@/data/site";

const sections = [
  { h: "Overview", p: "This Privacy Policy explains how AutoMex Group (\"AutoMex\", \"we\", \"us\") handles information you share through this website, primarily via our enquiry and contact forms." },
  { h: "Information We Collect", p: "When you submit an enquiry, we collect the details you provide — such as your name, company, designation, mobile number, email, project location, requirement, business vertical, estimated project size, expected start and any file you choose to upload." },
  { h: "How We Use Information", p: "We use your information solely to respond to your enquiry, understand your project requirement and coordinate a suitable response from our team. We do not sell your information." },
  { h: "Data Retention", p: "Enquiry details are retained for as long as needed to respond to and service your request, and to maintain our business records." },
  { h: "Sharing", p: "We may share relevant details internally within AutoMex verticals and with execution partners strictly to progress your enquiry. We do not share your data for third-party marketing." },
  { h: "Your Choices", p: "You may request access to, correction of, or deletion of your submitted information by contacting us using the details below." },
  { h: "Contact", p: `For any privacy questions, contact us at ${CONTACT.email} or ${CONTACT.phone}. AutoMex Group, ${CONTACT.location}.` },
];

export default function Privacy() {
  useSeo({
    title: "Privacy Policy | AutoMex Group",
    description: "Privacy Policy for AutoMex Group — how we handle information submitted through our website enquiry and contact forms.",
    path: "/privacy",
  });
  return (
    <>
      <PageHero overline="Legal" title="Privacy Policy" image={IMAGES.architecture} crumb="Privacy" />
      <section className="py-24 md:py-28 bg-white">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          {sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.03}>
              <div className="mb-10">
                <h2 className="font-heading text-2xl font-bold uppercase tracking-tight text-automex-ink">{s.h}</h2>
                <p className="mt-3 text-slate-600 leading-relaxed">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
